export const navFilter = (routes, user) => {
  let filter = [];
  let userRoles = [];

  if (user.role.constructor === Array) {
    userRoles.push(...user.role);
  } else {
    userRoles.push(user.role);
  }

  let navFilter = routes.filter(n => n.meta.nav === true);
  filter.push(...navFilter.filter(x => x.meta.roles === undefined));
  filter.push(...navFilter.filter(x => x.meta.roles !== undefined && x.meta.roles.some(z => userRoles.includes(z))));

  return filter;
};
